import { api } from '../../../res/constants';
import WS from './api';
import { toast } from 'react-toastify';

export const getAllHashtags = () => {
	const url = api.hashtags;

	return new Promise((resolve, reject) => {
		WS.axiosGet(url).then(
			(response) => {
				// console.log('HASHTAGS DATA= ', response);
				resolve(response.data.data);
			},
			(error) => {
				console.log('ERROR ', error);
				reject(error);
			}
		);
	});
};
